// Import Tailwind CSS
import './src/styles/tailwind.css';

import { Capacitor } from '@capacitor/core';

import { initPushNotifications } from './src/services/pushNotifications';

// Tag the document when running inside the native app, so the stylesheets can
// target it — both a generic class and a per-platform one, since iOS and
// Android lay the status bar out differently. The website is untouched: these
// classes are never added there.
export const onClientEntry = () => {
  if (typeof document === 'undefined') return;
  if (!Capacitor.isNativePlatform()) return;

  document.documentElement.classList.add('is-native-app', `is-native-${Capacitor.getPlatform()}`);

  // A double tap zooms the web view, and there is no address bar to get back
  // from it: the layout simply hangs off the side of the screen until the app
  // is killed. An application is not a document, and nobody expects to zoom
  // one by tapping twice. The website keeps its zoom untouched — pinching a
  // page is a real need there, and taking it away would fail accessibility.
  const viewport = document.querySelector('meta[name="viewport"]');

  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
  }

  initPushNotifications({
    onToken: (token) => {
      // TODO: send this token to the API once the user is authenticated, so
      // the backend can target this device.
      // eslint-disable-next-line no-console
      console.log('Push device token:', token);
    },
    onNotificationTap: (notification) => {
      // TODO: route the user based on notification.data if needed.
      // eslint-disable-next-line no-console
      console.log('Notification tapped:', notification);
    },
  });
};
